import { useEffect, useRef } from 'react';
import { useAnalytics } from './useAnalytics';
import { IAnalyticsTrack } from './useAnalyticsProvider';

/**
 * Similar to useEffect but runs only on mount (thus no deps) and passes the
 * `track` function from useAnalytics to avoid explicitly importing it at
 * usage side for convenience
 *
 * (Svilen): I'm still experimenting what's the best way to track "View" events
 * Sometimes the object we track (analysis, dashboard) changes unexpectedly
 * and using plain useEffect hook is not safe (we may end up firing the event
 * more than once).
 *
 * This hook is expected to be heavily refactored or removed when I accrue more
 * use cases during instrumentation of the rest of the events
 *
 * @param effect
 */
export const useAnalyticsEffect = (
  effect: (track: IAnalyticsTrack) => void,
) => {
  const { track } = useAnalytics();

  const effectFunc = useRef(effect);

  useEffect(() => {
    effectFunc.current(track);
  }, [track]);
};
